import fetch from 'cross-fetch';
import {
    translateResourceString
} from '../util/translationUtility';

import {
    ERROR_USER_ALERT,
} from '../SharedComponents/UserMessaging/';

export const fetchAccountOrganizationOptions = (endpointUrl) => {
    return fetch(
        endpointUrl,
        {
            headers: {
                'content-type': 'application/json',
                'X-Requested-With': 'fetch'
            },
            credentials: 'same-origin'
        }
    )
        .then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                if (typeof console !== 'undefined' && console.error) {
                    console.error(response);
                }
                throw new Error()
            }
        })
        .then(data => {
            if (!data || !data.options) {
                if (typeof console !== 'undefined' && console.error) {
                    console.error(data);
                }
                throw new Error("Invalid data format");
            }
            return { success: true, options: data.options };
        })
        .catch(() => {
            return {
                success: false,
                errorMessage: {
                    text: translateResourceString("/MyAccountPage/InvoicePayments/ErrorLoadingAccountOrganization"),
                    type: ERROR_USER_ALERT
                }
            }
        });
}